app.controller('PersonalDataController', [
  '$scope',
  '$location',
  '$window',
  'Services',
  'SessionStorage',
  '$anchorScroll',
  function($scope, $location, $window, $services, SessionStorage, $anchorScroll) {
    $scope.pc = pc
    $scope.titleList = [
      '-', 'dr.', 'Dr.', 'prof.', 'prof.dr.', 'id.', 'ifj.', 'özv.,ifj.',
      'ifj.,Dr.', 'legifj.', 'özv.'
    ]

    $scope.emailPattern = /^([a-zA-Z0-9])+([a-zA-Z0-9._%+-])+@([a-zA-Z0-9_.-])+\.(([a-zA-Z]){2,6})$/

    $scope.maxDate = moment()
    $scope.minDate = moment('1900-01-01')
    $scope.startDate = moment().subtract(30, 'year')
    $scope.nextButton=''
    $scope.cityList = []
    $scope.streetList = []
    $scope.postalCityList = []
    $scope.postalStreetList = []
    
    if (sessionStorage.getItem('registrationData')) {
      $scope.registrationData = SessionStorage.getRegistrationData()
      $scope.startDate = $scope.registrationData.birthdate.momentDate
      $scope.field1StartDate = $scope.registrationData.otherField1
      $scope.field2StartDate = $scope.registrationData.otherField2
      $scope.field3StartDate = $scope.registrationData.otherField3
      
    } else {
      $scope.registrationData = {}
    }
    
    $services.fillConfigLists().then(
    	function(res) {
        if (res.status === 'OK') {
  	      	setRegistrationCodeMask(res.data.registrationCode)
  	      	setRegistrationCodeMessage(res.data.registrationCodeMessage)
  	      	setInsuranceStartDateShow(res.data.insuranceStartDate.insuranceStartDateShow)
		    setInsuranceStartDateLabel(res.data.insuranceStartDate.insuranceStartDateLabel)
		    setInsuranceEndDateShow(res.data.insuranceEndDate.insuranceEndDateShow)
		    setInsuranceEndDateLabel(res.data.insuranceEndDate.insuranceEndDateLabel)
		    setinsuranceDate(res.data.insuranceDate.insuranceDate)
		    setUniqueFieldsMessage(res.data.uniqueMessages.uniqueFieldsMessage)
		    setUniqueFieldsMessageVisible(res.data.uniqueMessages.uniqueFieldsMessageVisible)
		    
          } else {
            $scope.errorMessages = res.messages
          }
        },
        function(error) {
          $scope.errorMessages = ['Ismeretlen hiba.']
        }
      )
    		
    		
    $services.getPageParameters().then(
      function(res) {
        if (res.status === 'OK') {
        	setFieldVisible1(res.data.field1.fieldVisible1)
            setLabelName1(res.data.field1.labelName1)
            
            setFieldVisible2(res.data.field2.fieldVisible2)
            setLabelName2(res.data.field2.labelName2)
            
            setFieldVisible3(res.data.field3.fieldVisible3)
            setLabelName3(res.data.field3.labelName3)
            
            setFieldVisible4(res.data.field4.fieldVisible4)
            setLabelName4(res.data.field4.labelName4)
            
            setFieldVisible5(res.data.field5.fieldVisible5)
            setLabelName5(res.data.field5.labelName5)
            
            setFieldVisible6(res.data.field6.fieldVisible6)
            setLabelName6(res.data.field6.labelName6)
            
            setFieldVisible7(res.data.field7.fieldVisible7)
            setLabelName7(res.data.field7.labelName7)
            
            setFieldVisible8(res.data.field8.fieldVisible8)
            setLabelName8(res.data.field8.labelName8)
            
            setFieldVisible9(res.data.field9.fieldVisible9)
            setLabelName9(res.data.field9.labelName9)
            
            setFieldVisible10(res.data.field10.fieldVisible10)
            setLabelName10(res.data.field10.labelName10)
            
            setFieldVisible11(res.data.field11.fieldVisible11)
            setLabelName11(res.data.field11.labelName11)
            
            setFieldVisible12(res.data.field12.fieldVisible12)
            setLabelName12(res.data.field12.labelName12)
            
            setFieldVisible13(res.data.field13.fieldVisible13)
            setLabelName13(res.data.field13.labelName13)
            
            setFieldVisible14(res.data.field14.fieldVisible14)
            setLabelName14(res.data.field14.labelName14)
            
            setFieldVisible15(res.data.field15.fieldVisible15)
            setLabelName15(res.data.field15.labelName15)
            
            setInsuranceStartDateShow(res.data.insuranceStartDate.insuranceStartDateShow)
		    setInsuranceStartDateLabel(res.data.insuranceStartDate.insuranceStartDateLabel)
		    
		    setInsuranceEndDateShow(res.data.insuranceEndDate.insuranceEndDateShow)
		    setInsuranceEndDateLabel(res.data.insuranceEndDate.insuranceEndDateLabel)
		    
		    setinsuranceDate(res.data.insuranceDate.insuranceDate)

		    setUniqueFieldsMessage(res.data.uniqueMessages.uniqueFieldsMessage)
		    setUniqueFieldsMessageVisible(res.data.uniqueMessages.uniqueFieldsMessageVisible)
		    
            
            $scope.registrationData.labelName1 = res.data.field1.labelName1
            $scope.registrationData.fieldVisible1 = res.data.field1.fieldVisible1
            $scope.registrationData.fieldType1 = "date"
            
            $scope.registrationData.labelName2 = res.data.field2.labelName2
            $scope.registrationData.fieldVisible2 = res.data.field2.fieldVisible2
            $scope.registrationData.fieldType2 = "date"
            
            $scope.registrationData.labelName3 = res.data.field3.labelName3
            $scope.registrationData.fieldVisible3 = res.data.field3.fieldVisible3
            $scope.registrationData.fieldType3 = "date"
            
            $scope.registrationData.labelName4 = res.data.field4.labelName4
            $scope.registrationData.fieldVisible4 = res.data.field4.fieldVisible4
            $scope.registrationData.fieldType4 = "text"
            
            $scope.registrationData.labelName5 = res.data.field5.labelName5
            $scope.registrationData.fieldVisible5 = res.data.field5.fieldVisible5
            $scope.registrationData.fieldType5 = "text"
            
            $scope.registrationData.labelName6 = res.data.field6.labelName6
            $scope.registrationData.fieldVisible6 = res.data.field6.fieldVisible6
            $scope.registrationData.fieldType6 = "text"
            
            $scope.registrationData.labelName7 = res.data.field7.labelName7
            $scope.registrationData.fieldVisible7 = res.data.field7.fieldVisible7
            $scope.registrationData.fieldType7 = "text"
            
            $scope.registrationData.labelName8 = res.data.field8.labelName8
            $scope.registrationData.fieldVisible8 = res.data.field8.fieldVisible8
            $scope.registrationData.fieldType8 = "text"
            
            $scope.registrationData.labelName9 = res.data.field9.labelName9
            $scope.registrationData.fieldVisible9 = res.data.field9.fieldVisible9
            $scope.registrationData.fieldType9 = "text"
            
            $scope.registrationData.labelName10 = res.data.field10.labelName10
            $scope.registrationData.fieldVisible10 = res.data.field10.fieldVisible10
            $scope.registrationData.fieldType10 = "text"
            
            $scope.registrationData.labelName11 = res.data.field11.labelName11
            $scope.registrationData.fieldVisible11 = res.data.field11.fieldVisible11
            $scope.registrationData.fieldType11 = "text"
            
            $scope.registrationData.labelName12 = res.data.field12.labelName12
            $scope.registrationData.fieldVisible12 = res.data.field12.fieldVisible12
            $scope.registrationData.fieldType12 = "text"
            
            $scope.registrationData.labelName13 = res.data.field13.labelName13
            $scope.registrationData.fieldVisible13 = res.data.field13.fieldVisible13
            $scope.registrationData.fieldType13 = "text"
            
            $scope.registrationData.labelName14 = res.data.field14.labelName14
            $scope.registrationData.fieldVisible14 = res.data.field14.fieldVisible14
            $scope.registrationData.fieldType14 = "text"
            
            $scope.registrationData.labelName15 = res.data.field15.labelName15
            $scope.registrationData.fieldVisible15 = res.data.field15.fieldVisible15
            $scope.registrationData.fieldType15 = "text"
            
        	$scope.registrationData.isAnyUniqueFieldVisible = res.data.isAnyUniqueFieldVisible.isAnyUniqueFieldVisible
        	$scope.registrationData.isAnyStatementVisible = res.data.isAnyStatementVisible.isAnyStatementVisible
        	$scope.registrationData.isPhoneNumberVisible = res.data.isPhoneNumberVisible.isPhoneNumberVisible
        	
        	$scope.registrationData.insuranceStartDateShow = res.data.insuranceStartDate.insuranceStartDateShow
        	$scope.registrationData.insuranceStartDateLabel = res.data.insuranceStartDate.insuranceStartDateLabel
            $scope.registrationData.insuranceStartDateShowType = "date"
            	
            $scope.registrationData.insuranceEndDateShow = res.data.insuranceEndDate.insuranceEndDateShow
            $scope.registrationData.insuranceEndDateLabel = res.data.insuranceEndDate.insuranceEndDateLabel
            $scope.registrationData.insuranceEndDateShowType = "date"
            
            $scope.registrationData.insuranceDate = res.data.insuranceDate.insuranceDate
            
            $scope.registrationData.uniqueFieldsMessage = res.data.uniqueMessages.uniqueFieldsMessage
            $scope.registrationData.uniqueFieldsMessageVisible = res.data.uniqueMessages.uniqueFieldsMessageVisible
            
        } else {
          setConfigDataVisible(false)
          $scope.errorMessages = res.messages
        }
      },
      function(error) {
        setConfigDataVisible(false)
        setConfigDataLabel(false)
        $scope.errorMessages = ['Ismeretlen hiba.']
      }
    )
    
    $scope.next = function() {
    	
    	$services.partnerCodeValidation($scope.registrationData).then(
    	function(res) {
	        if (res.status === 'OK') {
	  	      	if(res.data.result == "false"){
		  	    	   $scope.personalDataForm.nextButton.$setValidity('partnerCodeError', false)
		  	    }else{
	  	    	  		$scope.personalDataForm.nextButton.$setValidity('partnerCodeError', true)
	  	    	  		if ($scope.personalDataForm.$valid) {
		  	  	            SessionStorage.setRegistrationData($scope.registrationData)
				  	        window.scrollTo(0, 0)
				  	        $location.path('/osszesito')
		  	    	  	} else {
		  	          	window.scrollTo(0, angular.element(document.getElementsByTagName('ng-message'))[0].offsetTop - 80)
		  	            }
		  	      }
	        }else{
	        	
	        } 
    	}
    	)	
    }

    $scope.clearUserData = function() {
      sessionStorage.removeItem('registrationData')
      $scope.registrationData = {}
    }
    
    var setFieldVisible1 = function(mode) {
        $scope.fieldVisible1 = mode
    }
    
    var setLabelName1= function(mode) {
        $scope.labelName1 = mode
    }
    
    var setFieldVisible2 = function(mode) {
        $scope.fieldVisible2 = mode
    }
    
    var setLabelName2= function(mode) {
        $scope.labelName2 = mode
    }
    
    var setFieldVisible3 = function(mode) {
        $scope.fieldVisible3 = mode
    }
    
    var setLabelName3= function(mode) {
        $scope.labelName3 = mode
    }
    
    var setFieldVisible4 = function(mode) {
        $scope.fieldVisible4 = mode
    }
    
    var setLabelName4= function(mode) {
        $scope.labelName4 = mode
    }
    
    var setFieldVisible5 = function(mode) {
        $scope.fieldVisible5 = mode
    }
    
    var setLabelName5= function(mode) {
        $scope.labelName5 = mode
    }
    
    var setFieldVisible6 = function(mode) {
        $scope.fieldVisible6 = mode
    }
    
    var setLabelName6= function(mode) {
        $scope.labelName6 = mode
    }
    
    var setFieldVisible7 = function(mode) {
        $scope.fieldVisible7 = mode
    }
    
    var setLabelName7= function(mode) {
        $scope.labelName7 = mode
    }
    
    var setFieldVisible8 = function(mode) {
        $scope.fieldVisible8 = mode
    }
    
    var setLabelName8= function(mode) {
        $scope.labelName8 = mode
    }
    
    var setFieldVisible9 = function(mode) {
        $scope.fieldVisible9 = mode
    }
    
    var setLabelName9= function(mode) {
        $scope.labelName9 = mode
    }
    
    var setFieldVisible10 = function(mode) {
        $scope.fieldVisible10 = mode
    }
    
    var setLabelName10= function(mode) {
        $scope.labelName10 = mode
    }
    
    var setFieldVisible11 = function(mode) {
        $scope.fieldVisible11 = mode
    }
    
    var setLabelName11= function(mode) {
        $scope.labelName11= mode
    }
    
    var setFieldVisible12 = function(mode) {
        $scope.fieldVisible12 = mode
    }
    
    var setLabelName12= function(mode) {
        $scope.labelName12= mode
    }
	
	 var setFieldVisible13 = function(mode) {
        $scope.fieldVisible13 = mode
    }
    
    var setLabelName13 = function(mode) {
        $scope.labelName13 = mode
    }
    
    var setFieldVisible14 = function(mode) {
        $scope.fieldVisible14 = mode
    }
    
    var setLabelName14= function(mode) {
        $scope.labelName14 = mode
    }
    
    var setFieldVisible15 = function(mode) {
        $scope.fieldVisible15 = mode
    }
    
    var setLabelName15= function(mode) {
        $scope.labelName15 = mode
    }
    
    var setInsuranceStartDateShow = function(mode) {
		$scope.insuranceStartDateShow = mode
	}

    var setInsuranceStartDateLabel= function(mode) {
        $scope.insuranceStartDateLabel = mode
    }
    
    var setInsuranceEndDateShow = function(mode) {
		$scope.insuranceEndDateShow = mode
	}

    var setInsuranceEndDateLabel= function(mode) {
        $scope.insuranceEndDateLabel = mode
    }
    
    var setinsuranceDate= function(mode) {
        $scope.insuranceDate = mode
    }
    
    var setPhoneNumberVisible = function(mode) {
        $scope.phoneNumberVisible = mode
    }
    
    var setRegistrationCodeMask = function(mode) {
    	$scope.registrationData.registrationCodeMask = mode
    }
    
    var setRegistrationCodeMessage= function(mode) {
    	$scope.registrationData.registrationCodeMessage = mode
    }
    
    var setUniqueFieldsMessage= function(mode) {
    	$scope.registrationData.uniqueFieldsMessage = mode
    }
    
    var setUniqueFieldsMessageVisible= function(mode) {
    	$scope.registrationData.uniqueFieldsMessageVisible = mode
    }
    
	$scope.zipChange = function(zip) {
      if (zip && zip.length === 4) {
        $services.getCityList(zip).then(
          function(res) {
            if (res.status === 'OK') {
              $scope.cityList = res.data
              $scope.registrationData.city = res.data[0]
            } else {
              $scope.cityListError = true
            }

            if ($scope.cityList.length !== 0) {
              $scope.personalDataForm.zip.$setValidity('validZip', true)
            } else {
              $scope.personalDataForm.zip.$setValidity('validZip', false)
            }
          }
        )

        $services.getStreetList(zip).then(
          function(res) {
            if (res.status === 'OK') {
              $scope.streetList = res.data
            } else {
              $scope.streetListError = true
            }
          }
        )
      } else {
        $scope.cityList = []
        $scope.streetList = []
        delete $scope.registrationData.city
        delete $scope.registrationData.street
      }
    }
    
    $scope.postalZipChange = function(zip) {
        if (zip && zip.length === 4) {
          $services.getCityList(zip).then(
            function(res) {
              if (res.status === 'OK') {
                $scope.postalCityList = res.data
                $scope.registrationData.postalCity = res.data[0]
              } else {
                $scope.postalCityListError = true
              }

              if ($scope.postalCityList.length !== 0) {
                $scope.personalDataForm.postalZip.$setValidity('validPostalZip', true)
              } else {
                $scope.personalDataForm.postalZip.$setValidity('validPostalZip', false)
              }
            }
          )

          $services.getStreetList(zip).then(
            function(res) {
              if (res.status === 'OK') {
                $scope.postalStreetList = res.data
              } else {
                $scope.postalStreetListError = true
              }
            }
          )
        } else {
          $scope.postalCityList = []
          $scope.postalStreetList = []
          delete $scope.registrationData.postalCity
          delete $scope.registrationData.postalStreet
        }
      }
    
      $scope.gotoBottom = function() {
          // set the location.hash to the id of
          // the element you wish to scroll to.
          $location.hash('bottom');

          // call $anchorScroll()
          $anchorScroll();
      };
  }
])
